import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadStoryAccessGroupMembers from '../loadStoryAccessGroupMembers'

const fetchStoryAccessGroupMembers = (storyId) =>
  HttpClient().get(
    `/api/v1/stories/${storyId}/access_group/members/new?include=user,user.avatar`
  )

const getStoryAccessGroupMembers = (storyId) => (dispatch) =>
  fetchStoryAccessGroupMembers(storyId)
    .then((response) =>
      dispatch(
        loadStoryAccessGroupMembers({
          story_id: storyId,
          data: parseJSONApiResponse(response.data),
        })
      )
    )
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getStoryAccessGroupMembers
